export type PrimaryContactValues = {
  primaryContactOption: 'new' | 'existing';
  primaryContactFirstName: string;
  primaryContactLastName: string;
  primaryContactEmail: string;
  primaryContactId: string;
};

export type PrimaryContactInput =
  | { new: { firstName: string; lastName: string; email: string } }
  | { existingContactId: string };

export default function buildPrimaryContactInput(
  values: PrimaryContactValues,
): PrimaryContactInput {
  if (values.primaryContactOption === 'existing') {
    return { existingContactId: values.primaryContactId };
  }

  return {
    new: {
      firstName: values.primaryContactFirstName,
      lastName: values.primaryContactLastName,
      email: values.primaryContactEmail,
    },
  };
}
